
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apropos",
      function () {
        return require("private-next-pages/apropos/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/apropos"])
      });
    }
  